import React from "react";
import moment from "moment";
import { UsagePlan } from "pages/subscription/SubscriptionStyled";
import { formatNumber } from "utils/functions";
import { BILLING_CYCLE } from "api/interfaces/subscription.interface";
import {
  PlanEuListDto,
  StatCardResultDto,
  UsageStorageList,
  UsageStorageResult,
} from "api/interfaces/planInterface.interface";
import StorageAllocationPanel from "./StorageAllocationPanel";
import { CloudModalAccount } from "pages/subscription/modal/addCloud/AddCloudModal";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";

type Props = {
  summary: StatCardResultDto;
  cycle: BILLING_CYCLE;
  onOpenAddCloudModal: (account: CloudModalAccount) => void;
  storageAlloctaionData: UsageStorageResult | null;
  isFetching: boolean;
};

export default function StorageSummary(props: Props) {
  const { storageAlloctaionData } = props;
  const { planActiveDate }: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );

  return (
    <>
      <StorageAllocationPanel
        onAddCloudStorage={props.onOpenAddCloudModal}
        storageAlloctaionData={storageAlloctaionData}
      />

      {/* <UsagePlan.GraphWrapper className="storage-changes-panel">
          No storage allocation changes recorded.
        </UsagePlan.GraphWrapper> */}
      {/* {storageAlloctaionData !== null && (
        <UsagePlan.GraphWrapper className="storage-monthly-summary-panel">
          <div className="monthly-summary-header">
            <h3>Monthly Statement Summary</h3>
          </div>
          {(() => {
            const total = storageAlloctaionData.usage.amount ?? 0;
            const used = storageAlloctaionData.usage.used ?? 0;
            const remaining = total - used;
            const remainingMonths = (() => {
              if (!planActiveDate) return 0;
              const activatedAt = moment(planActiveDate);
              if (!activatedAt.isValid()) return 0;
              const expiryAt = activatedAt.clone().add(1, "year");
              return Math.max(0, expiryAt.diff(moment(), "months"));
            })();

            return (
              <div className="monthly-summary-body">
                <div className="summary-row">
                  <span>Current Allocation</span>
                  <b>{formatNumber(total)} TB</b>
                </div>
                <div className="summary-row">
                  <span>Credits Used This Month</span>
                  <b>{formatNumber(used)} TB months</b>
                </div>
                <div className="summary-divider" />
                <div className="summary-row">
                  <span>Credits Remaining</span>
                  <b>{formatNumber(remaining)} TB months</b>
                </div>
                <div className="summary-row">
                  <span>Remaining Month of Coverage</span>
                  <b>{formatNumber(remainingMonths)} months</b>
                </div>
              </div>
            );
          })()}
        </UsagePlan.GraphWrapper>
      )} */}
    </>
  );
}
